import React, { Component } from 'react';

import { HashRouter as Router, Route } from 'react-router-dom'
import { Provider } from 'mobx-react';

import store from '../store';
import shopStore from '../stores/shopStore';
import { textStore } from '../stores/textStore';
import DonationTicketView from '../views/DonationTicketView';
import { CURRENCIES } from '../constants/currencies';

export default class extends Component {
	constructor(props) {
		super(props);
		const context = window.tkcWidgetContext;		
		/*
		shopStore.setCart([context.sku], null, "100.00", context.ticketId);		
		shopStore.cart.set('hypoCashsale', {
			currencyname: "British pound",
			currencysymbol: "USD",
			discounttotal: "0.00",
			lineitems: [
				{
					amount: "50.00",
					description: "Donation Registration",
					item: "34",
					itemname: "EVENTBRITE DONATION TICKET",
					itemtype: "NonInvtPart",
					quantity: 1,	
				},			
			],
			subtotal: "50.00",
			total: "80.00",			
		});
		*/
	}

  	render() {
		const context = window.tkcWidgetContext;		
		store.netsuiteBaseUrl = context.netsuiteBaseUrl;
		store.guestSessionMode = true;	
		if (context.streamUrl) {
			store.guestSessionMode = false;	
			store.sessionToken = context.sessionToken;				
		}
		textStore.text = context.text;		
		//store.sessionToken = context.sessionToken;
		if (context.currency) {
			shopStore.currency.set(CURRENCIES[context.currency]);				 	
		}
		if (context.billingInfo) {
			shopStore.billingInfo.replace(context.billingInfo);
		}	  		
		return (
			<Provider store={store} shopStore={shopStore}>          
				<Router>
					<span className="_tkc-widget-container">                              
						<Route path="/" component={DonationTicketView} /> 
					</span>
				</Router>          
			</Provider>
		);
		
  	}

}




// WEBPACK FOOTER //
// ./src/apps/DonationTicketApp.js